import React, {Component} from "react";
import PanelGroupController from "../../../components/PanelGroupController";
import {connect} from "react-redux";
import {fromJS} from "immutable";
import InlineTable from "../../../components/InlineTable";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {graphql} from "react-apollo";
import {LIST_SHOP_LOCATIONS, ON_LOCATION_AVAILABILITY_UPDATED} from "../../../queries/sales";
import "./ShopLocationsPanel.css";

const FIELDS = fromJS([
  {field: "code", title: "Code", type: "string"},
  {field: "name", title: "Name", type: "string"},
  {field: "availability", title: "Status", type: "string"}
])

class ShopLocationsPanel extends Component {

  constructor(props) {
    super(props);
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const isLoaded = !this.props.loading;
    const hasSubscription = this.unsubscribeFromUpdates;
    if (hasSubscription && (prevProps.shopId !== this.props.shopId)) {
      this.unsubscribe();
    }
    if (isLoaded && !hasSubscription) {
      this.subscribe(this.props.shopId);
    }
  }

  subscribe(shopId) {
    this.unsubscribeFromUpdates = this.props.subscribeToUpdates(this.props, {});
  }

  unsubscribe() {
    if (this.unsubscribeFromUpdates) {
      this.unsubscribeFromUpdates();
      this.unsubscribeFromUpdates = null;
    }
  }


  render() {
    if (!this.props.active) {
      return (
        <PanelGroupController title="Shop Locations" expanded={this.props.expanded}>
          <p className="u-no-selection">Nothing selected</p>
        </PanelGroupController>
      )
    } 

    let {loading, error, shopLocations} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />      
    const locations = fromJS(shopLocations)
    let countries = locations.filter((x) => x.get("kind") === "country");
    let states = locations.filter((x) => x.get("kind") === "us-state");
    let ca_provinces = locations.filter((x) => x.get("kind") === "ca-province");
    return (
      <React.Fragment>
        {this.renderPanel(countries, "Shop Countries", this.props.expanded)}
        {this.renderPanel(states, "Shop US States", this.props.expanded, true)}
        {this.renderPanel(ca_provinces, "Shop CA Provinces", this.props.expanded, true)}
      </React.Fragment>
    )
  }

  renderPanel(items, title, expanded, hideWhenEmpty = false) {
    if (items.size === 0 && hideWhenEmpty) return null;
    return (
      <PanelGroupController title={title} expanded={expanded}>
        <InlineTable
          data={items}
          fields={FIELDS}
          dataType="shop_location"
          onItemClick={this.handleItemClick}
          />
      </PanelGroupController>
    )
  }

  handleItemClick(data) {
    this.props.requestChangeAvailabilityForLocation(data.get("shopId"), data.get("kind"), data.get("code"), data.get("name"));
  }

}

ShopLocationsPanel.defaultProps = {
  active: true
}


const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_LOCATION_AVAILABILITY_UPDATED,
      variables: {
        shopId: props.shopId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }  
})


const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(LIST_SHOP_LOCATIONS, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      shopId: props.shopId
    }
  })
});

export default withQuery(withSubscription(ShopLocationsPanel));